import HealingLogo from '@/assets/branding/healing/TWHSpng.png';

export default {
  name: 'Trauma Within Healing Center',
  isSAML: true,
  allowPersonalCourses: false,
  logo: HealingLogo,
  colors: {
    // Brand colors
    brand_primary: '#F35024',
    brand_primary_hover: '#CF3D15', // −10 L, −8 S
    brand_primary_highlight: '#FDA78F', // +23 L, +7 S
    brand_primary_mid: '#F76E49', // +8 L,  +2 S
    brand_primary_dark: '#8D260A', // −25 L, −3 S
    brand_secondary: '#B34218', // hue +4°, −15 L, −13 S
  },
};
